var exports = {
  "V": "x61f99309--1664a8--underline",
};

module.exports = exports;
